import React from "react";

function CostPerSaleIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="56.174" fill="#37367D" rx="5"></rect>
            <path
                fill="#fff"
                d="M34.063 21.475H23.438S16 27.86 16 35.313c0 4.256 3.198 6.386 5.312 6.386h14.876c2.123 0 5.312-2.13 5.312-6.386 0-7.452-7.438-13.838-7.438-13.838zM29.81 36.269v1.704H27.69v-1.699c-1.564-.29-2.547-1.258-2.617-2.662h1.84c.09.737.832 1.212 1.905 1.212.989 0 1.69-.481 1.69-1.166 0-.583-.454-.915-1.57-1.165l-1.184-.254c-1.657-.346-2.472-1.211-2.472-2.601s.925-2.392 2.396-2.721V25.2H29.8v1.719c1.436.32 2.393 1.302 2.44 2.622h-1.777c-.09-.72-.76-1.2-1.678-1.2-.919 0-1.582.442-1.582 1.136 0 .562.434.874 1.5 1.112l1.097.233c1.829.385 2.617 1.166 2.617 2.59 0 1.524-.977 2.544-2.606 2.856zM33.842 15.051h-2.938A3.201 3.201 0 0028.527 14a3.217 3.217 0 00-2.376 1.051h-2.939a1.07 1.07 0 00-.876.464 1.055 1.055 0 00-.11.982l.986 2.779h10.63l.987-2.78a1.052 1.052 0 00-.49-1.32 1.07 1.07 0 00-.497-.125z"
            ></path>
        </svg>
    );
}

export default CostPerSaleIcon;
